import { buildProjectBudgetQueryParams } from './utils'
import { api } from '../api'

export const projectBudgetApi = api
  .enhanceEndpoints({
    addTagTypes: ['ProjectBudget', 'ProjectBudgetChart'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getProjectBudget: builder.query({
        providesTags: ['ProjectBudget'],
        query: (filters) => {
          return {
            url: `/project-budget?${buildProjectBudgetQueryParams(filters)}`,
            method: 'GET',
          }
        },
        transformResponse: (response) => response?.data || {},
      }),
      getProjectBudgetChart: builder.query({
        providesTags: ['ProjectBudgetChart'],
        query: (filters) => ({
          url: `/project-budget/burnup-chart?${buildProjectBudgetQueryParams(
            filters
          )}`,
          method: 'GET',
        }),
        transformResponse: (response) => response?.data || {},
      }),
      downloadProjectBudgetFile: builder.query({
        query: (filters) => ({
          url: `/project-budget/xlsx?${buildProjectBudgetQueryParams(filters)}`,
          method: 'GET',
          responseHandler: async (response) => response.blob(),
          cache: 'no-cache',
        }),
      }),
    }),
  })

export const {
  useLazyGetProjectBudgetQuery,
  useLazyGetProjectBudgetChartQuery,
  useLazyDownloadProjectBudgetFileQuery,
} = projectBudgetApi
